export default __webpack_public_path__ + "static/media/logo.31432695.svg";